// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

// Define a service using a base URL and expected endpoints
export const courseApi = createApi({
  reducerPath: "courseApi",
  baseQuery: encryptedBaseQueryWithReauth(),
  // baseQuery: fetchBaseQuery({
  // baseUrl: process.env.REACT_APP_BASE_URL,
  // prepareHeaders: (headers,{ getState }) => {
  //   const token = localStorage.getItem("token");
  //    const uid = getState().users?.userInfo?._id;
  //   if (token) {
  //     headers.set("authorization", `Bearer ${token}`);
  //   }
  //   if (uid) headers.set("uid", uid);
  //   return headers;
  // },
  // baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_LOCAL_URL }),
  tagTypes: ["getCourses", "courseDetail"],
  endpoints: (builder) => ({
    getCourses: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getCourses"],
    }),
    getCoursesAnalytics: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getCoursesAnalytics"],
    }),

    getCoursesById: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["courseDetail"],
    }),

    updateCourse: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "PATCH",
        body: updatedData,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: ["courseDetail"],
    }),
    updatePromoted: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "PATCH",
        body: updatedData,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: ["courseDetail"],
    }),
    updateStatus: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "PATCH",
        body: updatedData,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: ["courseDetail"],
    }),

    createCourse: builder.mutation({
      query: ({ endpoint, newCourse }) => ({
        url: endpoint,
        method: "POST",
        body: newCourse,
      }),
      invalidatesTags: ["getCourses"],
    }),
    getCoursesByEntityType: builder.mutation({
      query: ({ endpoint, entityTypes }) => ({
        url: endpoint,
        method: "POST",
        body: entityTypes,
      }),
      invalidatesTags: ["getCoursesByEntityType"],
    }),

    linkCourse: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "POST",
        body: updatedData,
      }),

    }),

    getExamOverview: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    courseAccess: builder.mutation({
      query: ({ endpoint, payload }) => ({
        url: endpoint,
        method: "PATCH",
        body: payload,
        baseUrl: "https://api-prod.iverse.pro"
      }),
    }),

    // sinkCourse: builder.mutation({
    //   query: ({ endpoint, data }) => ({
    //     url: endpoint,
    //     method: "PATCH",
    //     body: data,
    //   }),
    // }),

    sinkCourse: builder.mutation({
  query: ({ endpoint, data }) => ({
    url: endpoint,
    method: "PATCH",
    body: data,
    baseUrl: "https://api-prod.iverse.pro", // custom base
  }),
}),


  }),
});

export const {
  useGetCoursesByIdQuery,
  useGetCoursesByEntityTypeMutation,
  useGetCoursesQuery,
  useCreateCourseMutation,
  useSinkCourseMutation,
  useCourseAccessMutation,
  useUpdateCourseMutation,
  useLinkCourseMutation,
  useGetCoursesAnalyticsQuery,
  useUpdatePromotedMutation,
  useUpdateStatusMutation,
  useGetExamOverviewQuery
} = courseApi;

